<template>
    <ValidationProvider :vid="$attrs.vid" :name="$attrs.vid" :rules="rules" v-slot="{errors}">
        <div class="form-group input-group-sm row thats-form">
            <label :for="$attrs.vid" class="col-form-label" :class="labelClass">{{$attrs.label}}</label>
            <div :class="fieldClass">
            <div class="md-form mt-0">
              <div class="input-container">
                
                <v-select ref="vselect" :multiple="multiple" v-bind:class="[{ 'no-append-btn' : !appendButton},hasError(errors),{'focus' : focus === true}]" @search:focus="onFocus" @search:blur="onBlur" @input="setSelected" :inputClass="hasError(errors)" v-model="inputValue" append-to-body :calculate-position="withPopper" :reduce="reduce" :label="reduceLabel" :options="options" :readOnly="readOnly" :disabled="disabled" :clearable="clearable">
                  <template #no-options>
                    No matching keyword found.  
                              
                  </template>

                  <template #list-footer>
                      <template v-if="addButton">
                        <li><mdb-btn class="dropdown-new" color="elegant" size="sm" @click="emitNewWindow">Add new</mdb-btn></li>
                    </template>
                </template>
                </v-select>
                <template v-if="appendButton">
                    <mdb-btn class="m-0 btn-three-dot" size="sm" @click="emitWindow"><mdb-icon icon="ellipsis-v" /></mdb-btn>
                  </template> 

                </div>

                <template v-if="show_error == true">
                    <span class="errors">{{errors[0]}}</span>
                </template>
            </div>
            </div>
        </div>
    </ValidationProvider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import { mdbBtn, mdbIcon, mdbClickOutside  } from "mdbvue";
import { createPopper } from '@popperjs/core';
export default {
    name : 'ThatsMultiSelect',
    props : {
        rules : {
            type : [Object, String],
            default : ''
        },
        type : {
            type : String,
            default : 'text'
        },
        value: {
            type: null
        },
        validated: {
            type: Boolean,
            default : false
        },
        options: {
            type: Array
        },

        labelClass : {
            type : String,
            default : 'col-md-3'
        },
        fieldClass : {
            type : String,
            default : 'col-md-9'
        },
        multiple : {
            type : Boolean,
            default : false
        },
        reduce :{
            type : Function,
            default: option => option,
        },
        reduceLabel :{
            type: String,
	        default: "label"
        },

        show_error: {
            type: Boolean,
            default : false
        },
        addButton: {
            type: Boolean,
            default : true
        },
        appendButton: {
            type: Boolean,
            default : true
        },
        disabled : {
            type : Boolean,
            default : false
        },
        readOnly : {
            type : Boolean,
            default : false
        },
        showLabel: {
            type: Boolean,
            default : true
        },
        horizontal: {
            type: Boolean,
            default : false
        },
        clearable: {
            type: Boolean,
            default : false
        },


    },
    directives: {
      mdbClickOutside
    },
    components : {
        ValidationProvider,
        mdbIcon,
        mdbBtn,
    },

    data : ()=>({
        inputValue : [],
        placement: 'bottom-start',
        focus : false
    }),

    methods : {
        handleOutsideClick() {
            // this.outsideClicks++;
        },
        setSelected(v){
            this.$emit('select',v)
        },
        onFocus(v){
        //   console.log("focus")
        this.focus = true
        },
        onBlur(v){
        //   console.log("focus")
        this.focus = false
        },
      emitNewWindow(){
          this.$refs.vselect.closeSearchOptions()
          this.$emit('newWindow')
              },
        emitWindow(e){
            this.$emit('window')
        },
        isValid(isInvalid,inpt){
            return ((isInvalid === true && inpt === '') || (inpt === '' && this.validated === true)) ? 'is-invalid' : null
        },
        hasError(error){
            return (error.length > 0) ? 'is-invalid' : null
        },

        
        withPopper(dropdownList, component, { width }) {
            const viewportPadding = 8
            const dropdownGap = 4
            const maximumHeight = 300

            dropdownList.style.setProperty('width', width, 'important')
            dropdownList.style.setProperty('max-width', `calc(100vw - ${viewportPadding * 2}px)`, 'important')
            dropdownList.style.overflowY = 'auto'

            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: this.placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, dropdownGap],
                        },
                    },
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['top-start'],
                            padding: viewportPadding,
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport',
                            rootBoundary: 'viewport',
                            altAxis: true,
                            padding: viewportPadding,
                        },
                    },
                    {
                        name: 'matchReferenceWidth',
                        enabled: true,
                        phase: 'beforeWrite',
                        requires: ['computeStyles'],
                        fn({ state }) {
                            state.styles.popper.width = `${state.rects.reference.width}px`
                        },
                    },
                    {
                        name: 'fitViewportHeight',
                        enabled: true,
                        phase: 'afterWrite',
                        fn({ state }) {
                            const referenceRect = state.elements.reference.getBoundingClientRect()
                            const opensAbove = state.placement.indexOf('top') === 0
                            const availableHeight = opensAbove
                                ? referenceRect.top - viewportPadding - dropdownGap
                                : window.innerHeight - referenceRect.bottom - viewportPadding - dropdownGap

                            dropdownList.style.setProperty(
                                'max-height',
                                `${Math.max(0, Math.min(maximumHeight, Math.floor(availableHeight)))}px`,
                                'important'
                            )
                            component.$el.classList.toggle('drop-up', opensAbove)
                        },
                    },
                ],
            })

            return () => {
                component.$el.classList.remove('drop-up')
                popper.destroy()
            }
        },


    },
    computed : {
        finalOptions : function () {
            const withSelected = [];
            this.options.forEach(element => {
                if(element.value === this.value){
                    // this.inputValue = element.value
                    element.selected = true
                    withSelected.push(element)
                }else{
                    withSelected.push(element)
                }
            });

            return withSelected;
        }
    },
    watch: {
    // Handles internal model changes.
        inputValue(newVal) {
            this.$emit("input", newVal);
        },
    // Handles external model changes.
        value(newVal) {
            
            this.inputValue = newVal;

        }
    },
    created() {
        if (this.value) {
        this.inputValue = this.value;
        }
    }
}

</script>
